export const SOCIAL_LINKS = {
    facebook: 'https://www.facebook.com/',
    instagram: 'https://www.instagram.com/',
    twitter: 'https://www.instagram.com/',
    youtube: 'https://www.youtube.com/',
};


export const TEAM_PLAYERS = [
    {
        number: 1,
        firstName: "Daniel Heur",
        lastName: "Fernandes",
        image: "daniel-fernandes.jpg",
        imagePng: "daniel-fernandes.png",
        position: "Goalkeeper"
    },
    {
        number: 12,
        firstName: "Tom",
        lastName: "Mickel",
        image: "tom-mickel.jpg",
        imagePng: "tom-mickel.png",
        position: "Goalkeeper"
    },
    {
        number: 19,
        firstName: "Matheo",
        lastName: "Raab",
        image: "matheo-raab.jpg",
        imagePng: "matheo-raab.png",
        position: "Goalkeeper"
    },
    {
        number: 40,
        firstName: "Haanes",
        lastName: "Herman",
        image: "hannes-herman.jpg",
        imagePng: "hannes-herman.png",
        position: "Goalkeeper"
    },
    {
        number: 2,
        firstName: "William",
        lastName: "Mikelbrencis",
        image: "william-mikelbrencis.jpg",
        imagePng: "william-mikelbrencis.png",
        position: "Right FullBack"
    },
    {
        number: 12,
        firstName: "Sebastian",
        lastName: "Schonlau",
        image: "sebastian-schonlau.jpg",
        imagePng: "sebastian-schonlau.png",
        position: "Center Right Back"
    },
    {
        number: 5,
        firstName: "Deniz",
        lastName: "Hadzikadunic",
        image: "dennis-hadzikadunic.jpg",
        imagePng: "dennis-hadzikadunic.png",
        position: "Center Left Back"
    },
    {
        number: 22,
        firstName: "Aboubaka",
        lastName: "Soumahoro",
        image: "aboubaka-soumahoro.jpg",
        imagePng: "aboubaka-soumahoro.png",
        position: "Left FullBack"
    },
    {
        number: 28,
        firstName: "Miro",
        lastName: "Muheim",
        image: "miro-muheim.jpg",
        imagePng: "miro-muheim.png",
        position: "Left FullBack"
    },
    {
        number: 30,
        firstName: "Silvan",
        lastName: "Hefti",
        image: "silvan-hefti.jpg",
        imagePng: "silvan-hefti.png",
        position: "Center Right Back"
    },
    {
        number: 33,
        firstName: "Noah",
        lastName: "Katterbach",
        image: "noah-katterbach.jpg",
        imagePng: "noah-katterbach.png",
        position: "Center Left Back"
    },
    {
        number: 37,
        firstName: "Valon",
        lastName: "Zumberi",
        image: "valon-zumberi.jpg",
        imagePng: "valon-zumberi.png",
        position: "Right FullBack"
    },
    {
        number: 39,
        firstName: "Joel",
        lastName: "Agyekum",
        image: "joel-agyekum.jpg",
        imagePng: "joel-agyekum.png",
        position: "Right Center Back"
    },
    {
        number: 47,
        firstName: "Nicolas",
        lastName: "Oliveira",
        image: "nicolas-oliveira.jpg",
        imagePng: "nicolas-oliveira.png",
        position: "Left Center Back"
    },
    {
        number: 6,
        firstName: "Lukasz",
        lastName: "Poreba",
        image: "lukasz-poreba.jpg",
        imagePng: "lukasz-poreba.png",
        position: "Midfielder"
    },
    {
        number: 8,
        firstName: "Daniel",
        lastName: "Elfadli",
        image: "daniel-elfadli.jpg",
        imagePng: "daniel-elfadli.png",
        position: "Midfielder"
    },
    {
        number: 10,
        firstName: "Immanuel",
        lastName: "Pherai",
        image: "immanuel-pherai.jpg",
        imagePng: "immanuel-pherai.png",
        position: "Midfielder"
    },
    {
        number: 14,
        firstName: "Ludovit",
        lastName: "Reis",
        image: "ludovit-reis.jpg",
        imagePng: "ludovit-reis.png",
        position: "Midfielder"
    },
    {
        number: 17,
        firstName: "Adam",
        lastName: "Karabec",
        image: "adam-karabec.jpg",
        imagePng: "adam-karabec.png",
        position: "Midfielder"
    },
    {
        number: 20,
        firstName: "Marco",
        lastName: "Richter",
        image: "marco-richter.jpg",
        imagePng: "marco-richter.png",
        position: "Midfielder"
    },
    {
        number: 23,
        firstName: "Jonas",
        lastName: "Meffert",
        image: "jonas-meffert.jpg",
        imagePng: "jonas-meffert.png",
        position: "Midfielder"
    },
    {
        number: 48,
        firstName: "Bilal",
        lastName: "Yalcinkaya",
        image: "bilal-yalcinkaya.jpg",
        imagePng: "bilal-yalcinkaya.png",
        position: "Midfielder"
    },
    {
        number: 7,
        firstName: "Jean-Luc",
        lastName: "Dompe",
        image: "jean-luc-dompe.jpg",
        imagePng: "jean-luc-dompe.png",
        position: "Striker"
    },
    {
        number: 9,
        firstName: "Robert",
        lastName: "Glatzel",
        image: "robert-glatzel.jpg",
        imagePng: "robert-glatzel.png",
        position: "Striker"
    },
    {
        number: 11,
        firstName: "Rans",
        lastName: "Konigsdorffer",
        image: "ransford-konigsdorffer.jpg",
        imagePng: "ransford-konigsdorffer.png",
        position: "Striker"
    },
    {
        number: 16,
        firstName: "Adedire",
        lastName: "Mebude",
        image: "adedire-mebude.jpg",
        imagePng: "adedire-mebude.png",
        position: "Striker"
    },
    {
        number: 18,
        firstName: "Bakery",
        lastName: "Jatta",
        image: "bakery-jatta.jpg",
        imagePng: "bakery-jatta.png",
        position: "Striker"
    },
    {
        number: 21,
        firstName: "Levin",
        lastName: "Oztunali",
        image: "levin-oztunali.jpg",
        imagePng: "levin-oztunali.png",
        position: "Striker"
    },
    {
        number: 27,
        firstName: "Davie",
        lastName: "Selke",
        image: "davie-selke.jpg",
        imagePng: "davie-selke.png",
        position: "Striker"
    },
    {
        number: 29,
        firstName: "Emir",
        lastName: "Sahiti",
        image: "emir-sahiti.jpg",
        imagePng: "emir-sahiti.png",
        position: "Striker"
    },
    {
        number: 38,
        firstName: "Alex",
        lastName: "Rossing-Lelesiit",
        image: "alexander-rossing-lelesiit.jpg",
        imagePng: "alexander-rossing-lelesiit.png",
        position: "Striker"
    },
    {
        number: 45,
        firstName: "Fabio",
        lastName: "Balde",
        image: "fabio-balde.jpg",
        imagePng: "fabio-balde.png",
        position: "Striker"
    },
    {
        number: 49,
        firstName: "Otto",
        lastName: "Stange",
        image: "otto-stange.jpg",
        imagePng: "otto-stange.png",
        position: "Striker"
    }
];


export const TEAM_STAFF = [
    {
        orderIndex: 1,
        name: "Merlin Polzin",
        function: "Head Coach",
        birthdate: "7th November 1990",
        nationality: "German",
        atHsvSince: "July 2020",
        image: "merlin-polzin.jpg"
    },
    {
        orderIndex: 2,
        name: "Loic Fave",
        function: "Assistant coach",
        birthdate: "11th February 1987",
        nationality: "German/French",
        atHsvSince: "January 2024",
        image: "loic-fave.jpg"
    },
    {
        orderIndex: 3,
        name: "Sven Höh",
        function: "Goalkeeping coach",
        birthdate: "4th April 1984",
        nationality: "German",
        atHsvSince: "June 2021",
        image: "sven-hoeh.jpg"
    },
    {
        orderIndex: 4,
        name: "Richard Krohn",
        function: "Assistant coach",
        birthdate: "15th July 1995",
        nationality: "German",
        atHsvSince: "July 2023",
        image: "richard-krohn.jpg"
    },
    {
        orderIndex: 5,
        name: "Jan Hasenkamp",
        function: "Athletic trainer",
        birthdate: "19th January 1974",
        nationality: "German",
        atHsvSince: "September 2006",
        image: "jan-hasenkamp.jpg"
    },
    {
        orderIndex: 6,
        name: "Sebastian Capel (UKE)",
        function: "Rehab coach",
        birthdate: "22nd August 1985",
        nationality: "German",
        atHsvSince: "September 2016",
        image: "sebastian-capel.jpg"
    },
    {
        orderIndex: 7,
        name: "Eduard Riesen",
        function: "Analyst",
        birthdate: "26th April 1993",
        nationality: "German/Romanian",
        atHsvSince: "September 2021",
        image: "eduard-riesen.jpg"
    }
];


export const TEAM_MEDICAL_AND_MANAGEMENT = [
    {
        orderIndex: 1,
        name: "PD Dr. Götz Welsch",
        function: "Head Team Doctor",
        birthdate: "16.10.1974 in Hof",
        nationality: "German",
        atHsvSince: "1st August 2014",
        image: "goetz-welsch.jpg"
    },
    {
        orderIndex: 2,
        name: "Dr. Wolfgang Schillings",
        function: "Team Doctor",
        birthdate: "10.10.1971 in Grevenbroich",
        nationality: "German",
        atHsvSince: "1st January 2012",
        image: "wolfgang-schillings.jpg"
    },
    {
        orderIndex: 3,
        name: "Andreas Thum",
        function: "Physiotherapist",
        birthdate: "18.04.1978 in Nördlingen",
        nationality: "German",
        atHsvSince: "1st July 2015",
        image: "andreas-thum.jpg"
    },
    {
        orderIndex: 4,
        name: "Tim Roussis",
        function: "Physiotherapist",
        birthdate: "8th November 1988 in Velbert",
        nationality: "German/Greek",
        atHsvSince: "August 2024",
        image: "tim-roussis.jpg"
    },
    {
        orderIndex: 5,
        name: "Gerrit Lüders",
        function: "Physiotherapist",
        birthdate: "15.12.1990 in Hamburg",
        nationality: "German",
        atHsvSince: "2019",
        image: "gerrit-lueders.jpg"
    },
    {
        orderIndex: 6,
        name: "Mats Wesling",
        function: "Team Manager",
        birthdate: "04.04.1994",
        nationality: "German",
        atHsvSince: "1st October 2016",
        image: "mats-wesling.jpg"
    },
    {
        orderIndex: 7,
        name: "Miroslav Zadach",
        function: "Kitman",
        birthdate: "05.11.1960 in Gdansk",
        nationality: "German",
        atHsvSince: "1st July 2005",
        image: "miroslav-zadach.jpg"
    },
    {
        orderIndex: 8,
        name: "Ramiro Guerron",
        function: "Kitman",
        birthdate: "31.03.1984",
        nationality: "German",
        atHsvSince: "8th May 2020",
        image: "ramiro-guerron.jpg"
    },
    {
        orderIndex: 9,
        name: "Chiara Behrens de Luna",
        function: "Team Psychologist",
        birthdate: "23rd April 1993 in Berlin",
        nationality: "German/Spanish",
        atHsvSince: "September 2023",
        image: "chiara-behrens-de-luna.jpg"
    }
];



export const FRIENDLIES = [
    {
        season: "2024/25",
        games: [
            {
                date: "2024-07-06",
                time: "14:00 CEST",
                location: "Jahn-Stadium, Neetze",
                home: "TuS Neetze",
                away: "Hamburger SV",
                result: "0:12"
            },
            {
                date: "2024-07-12",
                time: "19:00 CEST",
                location: "Kehdinger Stadium, Drochtersen",
                home: "SV Drochtersen/Assel",
                away: "Hamburger SV",
                result: "1:5"
            },
            {
                date: "2024-07-13",
                time: "17:00 CEST",
                location: "Stadion an der Lohmühle, Lübeck",
                home: "VfB Lübeck",
                away: "Hamburger SV",
                result: "2:5"
            },
            {
                date: "2024-07-20",
                time: "15:00 CEST",
                location: "Saalfelden Arena, Austria",
                home: "Hamburger SV",
                away: "FC Nantes",
                result: "4:2"
            },
            {
                date: "2024-07-21",
                time: "16:00 CEST",
                location: "Smaragdarena Bramberg, Austria",
                home: "Hamburger SV",
                away: "Cardiff City FC",
                result: "0:3"
            },
            {
                date: "2024-07-25",
                time: "14:00 CEST",
                location: "Kuftstein Arena, Austria",
                home: "Hamburger SV",
                away: "Aris Limassol",
                result: "0:0"
            },
            {
                date: "2024-09-05",
                time: "13:00 CEST",
                location: "Training center, Hamburg",
                home: "Hamburger SV",
                away: "KSV Holstein Kiel",
                result: "0:1"
            },
            {
                date: "2024-10-10",
                time: "13:00 CEST",
                location: "Training center, Hamburg",
                home: "Hamburger SV",
                away: "Aarhus GF",
                result: "1:1"
            },
            {
                date: "2024-11-13",
                time: "16:00 CEST",
                location: "Training center, Hamburg",
                home: "Hamburger SV",
                away: "Twente Enschede",
                result: "2:4"
            }
        ]
    },
    {
        season: "2023/24",
        games: [
            {
                date: "2023-07-02",
                time: "15:00 CEST",
                location: "Sportanlage Verden, Verden",
                home: "FC Verden 04",
                away: "Hamburger SV",
                result: "2:3"
            },
            {
                date: "2023-07-07",
                time: "18:00 CEST",
                location: "Westendorf, Austria",
                home: "Viktoria Pilsen",
                away: "Hamburger SV",
                result: "3:3"
            },
            {
                date: "2023-07-15",
                time: "10:30 CEST",
                location: "Anif, Austria",
                home: "FC Red Bull Salzburg",
                away: "Hamburger SV",
                result: "4:1"
            },
            {
                date: "2023-07-22",
                time: "15:00 CEST",
                location: "Ibrox Stadium, Glasgow, Scotland",
                home: "Rangers FC",
                away: "Hamburger SV",
                result: "2:1"
            }
        ]
    },
    {
        season: "2022/23",
        games: [
            {
                date: "2022-06-29",
                time: "17:30 CEST",
                location: "Fürstenfeld",
                home: "Hamburger SV",
                away: "Hajduk Split",
                result: "2:2"
            },
            {
                date: "2022-07-01",
                time: "17:30 CEST",
                location: "Söchau",
                home: "Hamburger SV",
                away: "Aris Thessaloniki",
                result: "4:3"
            },
            {
                date: "2022-07-09",
                time: "17:30 CEST",
                location: "Basel",
                home: "FC Basel 1893",
                away: "Hamburger SV",
                result: "1:5"
            },
            {
                date: "2022-09-22",
                time: null,
                location: "Hamburg",
                home: "Hamburger SV",
                away: "FC Nordsjaelland",
                result: "2:2"
            },
            {
                date: "2022-11-15",
                time: "19:00 PST",
                location: "Championship Soccer Stadium, Irvine (California) USA",
                home: "Orange County Soccer Club",
                away: "Hamburger SV",
                result: "0:1"
            },
            {
                date: "2022-11-18",
                time: "19:00 PST",
                location: "College Sportplatz, Ventura (California) USA",
                home: "Ventura Club Fusion",
                away: "Hamburger SV",
                result: "0:7"
            },
            {
                date: "2022-01-07",
                time: "15:30 CEST",
                location: "Franz-Kremer-Stadion, Köln",
                home: "Hamburger SV",
                away: "1. FC Köln",
                result: "4:0"
            }
        ]
    }
];


export const DFB_POKAL = [
    {
        season: "2024/25",
        matches: [
            {
                round: "2nd Round",
                date: "2024-10-30",
                time: "18:00 CEST",
                home: "SC Freiburg",
                away: "HSV",
                result: "2:1"
            },
            {
                round: "1st Round",
                date: "2024-08-18",
                time: "18:00 CEST",
                home: "SV Meppen",
                away: "HSV",
                result: "1:7"
            }
        ]
    },
    {
        season: "2023/24",
        matches: [
            {
                round: "Round of 16",
                date: "2023-12-06",
                time: "20:45 CEST",
                home: "Hertha BSC",
                away: "HSV",
                result: "8:6 o.p."
            },
            {
                round: "2nd Round",
                date: "2023-10-31",
                time: "20:45 CEST",
                home: "Arminia Bielefeld",
                away: "HSV",
                result: "4:5 o.p."
            },
            {
                round: "1st Round",
                date: "2023-08-13",
                time: "13:00 CEST",
                home: "Rot-Weiss Essen",
                away: "HSV",
                result: "3:4 n.V."
            }
        ]
    },
    {
        season: "2022/23",
        matches: [
            {
                round: "2nd Round",
                date: "2022-10-18",
                time: "18:00 CEST",
                home: "RB Leipzig",
                away: "HSV",
                result: "4:0"
            },
            {
                round: "1st Round",
                date: "2022-07-30",
                time: "15:30 CEST",
                home: "SpVgg Bayreuth",
                away: "HSV",
                result: "1:3"
            }
        ]
    },
    {
        season: "2021/22",
        matches: [
            {
                round: "Semi-Final",
                date: "2022-04-19",
                time: "20:45 CET",
                home: "Hamburger SV",
                away: "SC Freiburg",
                result: "1:3"
            },
            {
                round: "Quarter-Final",
                date: "2022-03-02",
                time: "18:30 CET",
                home: "Hamburger SV",
                away: "Karlsruher SC",
                result: "2:2 (3:2 Pens)"
            },
            {
                round: "Last 16",
                date: "2022-01-18",
                time: "18:30 CEST",
                home: "1.FC Köln",
                away: "Hamburger SV",
                result: "1:1 (3:4 Pens)"
            },
            {
                round: "Round 2",
                date: "2021-10-26",
                time: "20:45 CEST",
                home: "1.FC Nürnberg",
                away: "Hamburger SV",
                result: "1:1 (2:4 Pens)"
            },
            {
                round: "1st Round",
                date: "2021-08-08",
                time: "18:30 CEST",
                home: "Eintracht Braunschweig",
                away: "Hamburger SV",
                result: "1:2"
            }
        ]
    }
];


export const HSV_FIXTURES = {
    "2024/25": [
        { md: 1, date: "Fr., 02.08.24", time: "20.30 CEST", home: "1. FC Köln", away: "HSV", result: "1:2" },
        { md: 2, date: "Sa, 10.08.24", time: "20.30 CEST", home: "HSV", away: "Hertha BSC", result: "1:1" },
        { md: 3, date: "Fr., 23.08.24", time: "18.30 CEST", home: "Hannover 96", away: "HSV", result: "1:0" },
        { md: 4, date: "Sa., 31.08.24", time: "13.00 CEST", home: "HSV", away: "Preußen Münster", result: "4:1" },
        { md: 5, date: "Su., 15.09.24", time: "13.30 CEST", home: "HSV", away: "Jahn Regensburg", result: "5:0" },
        { md: 6, date: "Sa., 21.09.24", time: "20.30 CEST", home: "1. FC Kaiserslautern", away: "HSV", result: "2:2" },
        { md: 7, date: "Sa., 28.09.24", time: "13.00 CEST", home: "HSV", away: "SC Paderborn 07", result: "2:2" },
        { md: 8, date: "Su., 06.10.24", time: "13.30 CEST", home: "Fortuna Düsseldorf", away: "HSV", result: "0:3" },
        { md: 9, date: "Su, 20.10.24", time: "13.30 CEST", home: "HSV", away: "1. FC Magdeburg", result: "3:1" },
        { md: 10, date: "Sa., 26.10.24", time: "13.00 CEST", home: "SV Elversberg", away: "HSV", result: "4:2" },
        { md: 11, date: "Su., 03.11.24", time: "13.30 CEST", home: "HSV", away: "1. FC Nürnberg", result: "1:1" },
        { md: 12, date: "Fr., 08.11.24", time: "18.30 CEST", home: "Eintracht Braunschweig", away: "HSV", result: "3:1" },
        { md: 13, date: "Sa., 23.11.24", time: "20.30 CEST", home: "HSV", away: "FC Schalke 04", result: "2:2" },
        { md: 14, date: "Su, 01.12.24", time: "13.30 CEST", home: "Karlsruher SC", away: "HSV", result: "1:3" },
        { md: 15, date: "06.12.-08.12.24", time: "-", home: "HSV", away: "SV Darmstadt 98", result: "2:2" },
        { md: 16, date: "13.12.-15.12.24", time: "-", home: "SSV Ulm", away: "HSV", result: "1:1" },
        { md: 17, date: "20.12.-22.12.24", time: "-", home: "HSV", away: "SpVgg Greuther Fürth", result: "5:0" },
        { md: 18, date: "17.01.-19.01.25", time: "-", home: "HSV", away: "1. FC Köln", result: "1:0" },
        { md: 19, date: "24.01.-26.01.25", time: "-", home: "Hertha BSC", away: "HSV", result: "2:3" },
        { md: 20, date: "31.01.-02.02.25", time: "-", home: "HSV", away: "Hannover 96", result: "2:2" },
        { md: 21, date: "07.02.-09.02.25", time: "-", home: "Preußen Münster", away: "HSV", result: "1:2" },
        { md: 22, date: "14.02.-16.02.25", time: "-", home: "Jahn Regensburg", away: "HSV", result: "1:1" },
        { md: 23, date: "21.02.-23.02.25", time: "-", home: "HSV", away: "1. FC Kaiserslautern", result: "3:0" },
        { md: 24, date: "28.02.-02.03.25", time: "-", home: "SC Paderborn 07", away: "HSV", result: "2:0" },
        { md: 25, date: "07.03.-09.03.25", time: "-", home: "HSV", away: "Fortuna Düsseldorf", result: "4:1" },
        { md: 26, date: "14.03.-16.03.25", time: "-", home: "1. FC Magdeburg", away: "HSV", result: "0:3" },
        { md: 27, date: "28.03.-30.03.25", time: "-", home: "HSV", away: "SV Elversberg", result: "0:0" },
        { md: 28, date: "04.04.-06.04.25", time: "-", home: "1. FC Nürnberg", away: "HSV", result: "0:3" },
        { md: 29, date: "11.04.-13.04.25", time: "-", home: "HSV", away: "Eintracht Braunschweig", result: "2:4" },
        { md: 30, date: "19.04.-20.04.25", time: "-", home: "FC Schalke 04", away: "HSV", result: "2:2" },
        { md: 31, date: "25.04.-27.04.25", time: "-", home: "HSV", away: "Karlsruher SC", result: "1:2" },
        { md: 32, date: "02.05.-04.05.25", time: "-", home: "SV Darmstadt 98", away: "HSV", result: "0:4" },
        { md: 33, date: "09.05.-11.05.25", time: "-", home: "HSV", away: "SSV Ulm", result: "6:1" },
        { md: 34, date: "18.05.25", time: "15.30 CEST", home: "SpVgg Greuther Fürth", away: "HSV", result: "3:2" }
    ],

    "2023/24": [],
    "2022/23": []
};



export const HSV_TOURNAMENTS = [
    {
        "league": {
            "id": 78,
            "name": "Bundesliga",
            "type": "League",
            "logo": "https://media.api-sports.io/football/leagues/78.png"
        },
        "country": {
            "name": "Germany",
            "code": "DE",
            "flag": "https://media.api-sports.io/flags/de.svg"
        },
        "seasons": [
            {
                "year": 2010,
                "start": "2010-08-20",
                "end": "2011-05-14",
                "current": false,
                "coverage": {
                    "fixtures": {
                        "events": true,
                        "lineups": true,
                        "statistics_fixtures": false,
                        "statistics_players": false
                    },
                    "standings": true,
                    "players": true,
                    "top_scorers": true,
                    "top_assists": true,
                    "top_cards": true,
                    "injuries": false,
                    "predictions": true,
                    "odds": false
                }
            },
            {
                "year": 2011,
                "start": "2011-08-05",
                "end": "2012-05-05",
                "current": false,
                "coverage": {
                    "fixtures": {
                        "events": true,
                        "lineups": true,
                        "statistics_fixtures": false,
                        "statistics_players": false
                    },
                    "standings": true,
                    "players": true,
                    "top_scorers": true,
                    "top_assists": true,
                    "top_cards": true,
                    "injuries": false,
                    "predictions": true,
                    "odds": false
                }
            },
            {
                "year": 2012,
                "start": "2012-08-24",
                "end": "2013-05-18",
                "current": false,
                "coverage": {
                    "fixtures": {
                        "events": true,
                        "lineups": true,
                        "statistics_fixtures": false,
                        "statistics_players": false
                    },
                    "standings": true,
                    "players": true,
                    "top_scorers": true,
                    "top_assists": true,
                    "top_cards": true,
                    "injuries": false,
                    "predictions": true,
                    "odds": false
                }
            },
            {
                "year": 2013,
                "start": "2013-08-09",
                "end": "2014-05-10",
                "current": false,
                "coverage": {
                    "fixtures": {
                        "events": true,
                        "lineups": true,
                        "statistics_fixtures": false,
                        "statistics_players": false
                    },
                    "standings": true,
                    "players": true,
                    "top_scorers": true,
                    "top_assists": true,
                    "top_cards": true,
                    "injuries": false,
                    "predictions": true,
                    "odds": false
                }
            },
            {
                "year": 2014,
                "start": "2014-08-22",
                "end": "2015-05-23",
                "current": false,
                "coverage": {
                    "fixtures": {
                        "events": true,
                        "lineups": true,
                        "statistics_fixtures": false,
                        "statistics_players": false
                    },
                    "standings": true,
                    "players": true,
                    "top_scorers": true,
                    "top_assists": true,
                    "top_cards": true,
                    "injuries": false,
                    "predictions": true,
                    "odds": false
                }
            },
            {
                "year": 2015,
                "start": "2015-08-14",
                "end": "2016-05-14",
                "current": false,
                "coverage": {
                    "fixtures": {
                        "events": true,
                        "lineups": true,
                        "statistics_fixtures": true,
                        "statistics_players": true
                    },
                    "standings": true,
                    "players": true,
                    "top_scorers": true,
                    "top_assists": true,
                    "top_cards": true,
                    "injuries": false,
                    "predictions": true,
                    "odds": false
                }
            },
            {
                "year": 2016,
                "start": "2016-08-26",
                "end": "2017-05-20",
                "current": false,
                "coverage": {
                    "fixtures": {
                        "events": true,
                        "lineups": true,
                        "statistics_fixtures": true,
                        "statistics_players": true
                    },
                    "standings": true,
                    "players": true,
                    "top_scorers": true,
                    "top_assists": true,
                    "top_cards": true,
                    "injuries": false,
                    "predictions": true,
                    "odds": false
                }
            },
            {
                "year": 2017,
                "start": "2017-08-18",
                "end": "2018-05-12",
                "current": false,
                "coverage": {
                    "fixtures": {
                        "events": true,
                        "lineups": true,
                        "statistics_fixtures": true,
                        "statistics_players": true
                    },
                    "standings": true,
                    "players": true,
                    "top_scorers": true,
                    "top_assists": true,
                    "top_cards": true,
                    "injuries": false,
                    "predictions": true,
                    "odds": false
                }
            },
            {
                "year": 2021,
                "start": "2021-08-13",
                "end": "2022-05-23",
                "current": false,
                "coverage": {
                    "fixtures": {
                        "events": true,
                        "lineups": true,
                        "statistics_fixtures": true,
                        "statistics_players": true
                    },
                    "standings": true,
                    "players": true,
                    "top_scorers": true,
                    "top_assists": true,
                    "top_cards": true,
                    "injuries": true,
                    "predictions": true,
                    "odds": false
                }
            },
            {
                "year": 2022,
                "start": "2022-08-05",
                "end": "2023-06-05",
                "current": false,
                "coverage": {
                    "fixtures": {
                        "events": true,
                        "lineups": true,
                        "statistics_fixtures": true,
                        "statistics_players": true
                    },
                    "standings": true,
                    "players": true,
                    "top_scorers": true,
                    "top_assists": true,
                    "top_cards": true,
                    "injuries": true,
                    "predictions": true,
                    "odds": false
                }
            }
        ]
    },
    {
        "league": {
            "id": 81,
            "name": "DFB Pokal",
            "type": "Cup",
            "logo": "https://media.api-sports.io/football/leagues/81.png"
        },
        "country": {
            "name": "Germany",
            "code": "DE",
            "flag": "https://media.api-sports.io/flags/de.svg"
        },
        "seasons": [
            {
                "year": 2011,
                "start": "2011-07-29",
                "end": "2012-05-12",
                "current": false,
                "coverage": {
                    "fixtures": {
                        "events": true,
                        "lineups": true,
                        "statistics_fixtures": false,
                        "statistics_players": false
                    },
                    "standings": false,
                    "players": true,
                    "top_scorers": true,
                    "top_assists": true,
                    "top_cards": true,
                    "injuries": false,
                    "predictions": true,
                    "odds": false
                }
            },
            {
                "year": 2012,
                "start": "2012-08-17",
                "end": "2013-06-01",
                "current": false,
                "coverage": {
                    "fixtures": {
                        "events": true,
                        "lineups": true,
                        "statistics_fixtures": false,
                        "statistics_players": false
                    },
                    "standings": false,
                    "players": true,
                    "top_scorers": true,
                    "top_assists": true,
                    "top_cards": true,
                    "injuries": false,
                    "predictions": true,
                    "odds": false
                }
            },
            {
                "year": 2013,
                "start": "2013-08-02",
                "end": "2014-05-17",
                "current": false,
                "coverage": {
                    "fixtures": {
                        "events": true,
                        "lineups": true,
                        "statistics_fixtures": false,
                        "statistics_players": false
                    },
                    "standings": false,
                    "players": true,
                    "top_scorers": true,
                    "top_assists": true,
                    "top_cards": true,
                    "injuries": false,
                    "predictions": true,
                    "odds": false
                }
            },
            {
                "year": 2014,
                "start": "2014-08-15",
                "end": "2015-05-30",
                "current": false,
                "coverage": {
                    "fixtures": {
                        "events": true,
                        "lineups": true,
                        "statistics_fixtures": false,
                        "statistics_players": false
                    },
                    "standings": false,
                    "players": true,
                    "top_scorers": true,
                    "top_assists": true,
                    "top_cards": true,
                    "injuries": false,
                    "predictions": true,
                    "odds": false
                }
            },
            {
                "year": 2015,
                "start": "2015-08-07",
                "end": "2016-05-21",
                "current": false,
                "coverage": {
                    "fixtures": {
                        "events": true,
                        "lineups": true,
                        "statistics_fixtures": true,
                        "statistics_players": false
                    },
                    "standings": false,
                    "players": true,
                    "top_scorers": true,
                    "top_assists": true,
                    "top_cards": true,
                    "injuries": false,
                    "predictions": true,
                    "odds": false
                }
            },
            {
                "year": 2016,
                "start": "2016-08-19",
                "end": "2017-05-27",
                "current": false,
                "coverage": {
                    "fixtures": {
                        "events": true,
                        "lineups": true,
                        "statistics_fixtures": true,
                        "statistics_players": true
                    },
                    "standings": false,
                    "players": true,
                    "top_scorers": true,
                    "top_assists": true,
                    "top_cards": true,
                    "injuries": false,
                    "predictions": true,
                    "odds": false
                }
            },
            {
                "year": 2017,
                "start": "2017-08-11",
                "end": "2018-05-19",
                "current": false,
                "coverage": {
                    "fixtures": {
                        "events": true,
                        "lineups": true,
                        "statistics_fixtures": true,
                        "statistics_players": true
                    },
                    "standings": false,
                    "players": true,
                    "top_scorers": true,
                    "top_assists": true,
                    "top_cards": true,
                    "injuries": false,
                    "predictions": true,
                    "odds": false
                }
            },
            {
                "year": 2018,
                "start": "2018-08-17",
                "end": "2019-05-25",
                "current": false,
                "coverage": {
                    "fixtures": {
                        "events": true,
                        "lineups": true,
                        "statistics_fixtures": true,
                        "statistics_players": true
                    },
                    "standings": false,
                    "players": true,
                    "top_scorers": true,
                    "top_assists": true,
                    "top_cards": true,
                    "injuries": false,
                    "predictions": true,
                    "odds": false
                }
            },
            {
                "year": 2019,
                "start": "2019-08-09",
                "end": "2020-07-04",
                "current": false,
                "coverage": {
                    "fixtures": {
                        "events": true,
                        "lineups": true,
                        "statistics_fixtures": true,
                        "statistics_players": true
                    },
                    "standings": false,
                    "players": true,
                    "top_scorers": true,
                    "top_assists": true,
                    "top_cards": true,
                    "injuries": false,
                    "predictions": true,
                    "odds": false
                }
            },
            {
                "year": 2020,
                "start": "2020-09-11",
                "end": "2021-05-13",
                "current": false,
                "coverage": {
                    "fixtures": {
                        "events": true,
                        "lineups": true,
                        "statistics_fixtures": true,
                        "statistics_players": true
                    },
                    "standings": false,
                    "players": true,
                    "top_scorers": true,
                    "top_assists": true,
                    "top_cards": true,
                    "injuries": false,
                    "predictions": true,
                    "odds": false
                }
            },
            {
                "year": 2021,
                "start": "2021-08-06",
                "end": "2022-05-21",
                "current": false,
                "coverage": {
                    "fixtures": {
                        "events": true,
                        "lineups": true,
                        "statistics_fixtures": true,
                        "statistics_players": true
                    },
                    "standings": false,
                    "players": true,
                    "top_scorers": true,
                    "top_assists": true,
                    "top_cards": true,
                    "injuries": false,
                    "predictions": true,
                    "odds": false
                }
            },
            {
                "year": 2022,
                "start": "2022-07-29",
                "end": "2023-06-03",
                "current": false,
                "coverage": {
                    "fixtures": {
                        "events": true,
                        "lineups": true,
                        "statistics_fixtures": true,
                        "statistics_players": true
                    },
                    "standings": false,
                    "players": true,
                    "top_scorers": true,
                    "top_assists": true,
                    "top_cards": true,
                    "injuries": false,
                    "predictions": true,
                    "odds": false
                }
            },
            {
                "year": 2023,
                "start": "2023-08-11",
                "end": "2024-05-25",
                "current": false,
                "coverage": {
                    "fixtures": {
                        "events": true,
                        "lineups": true,
                        "statistics_fixtures": true,
                        "statistics_players": true
                    },
                    "standings": false,
                    "players": true,
                    "top_scorers": true,
                    "top_assists": true,
                    "top_cards": true,
                    "injuries": false,
                    "predictions": true,
                    "odds": false
                }
            },
            {
                "year": 2024,
                "start": "2024-08-16",
                "end": "2025-05-24",
                "current": true,
                "coverage": {
                    "fixtures": {
                        "events": true,
                        "lineups": true,
                        "statistics_fixtures": true,
                        "statistics_players": true
                    },
                    "standings": false,
                    "players": true,
                    "top_scorers": true,
                    "top_assists": true,
                    "top_cards": true,
                    "injuries": false,
                    "predictions": true,
                    "odds": true
                }
            }
        ]
    },
    {
        "league": {
            "id": 79,
            "name": "2. Bundesliga",
            "type": "League",
            "logo": "https://media.api-sports.io/football/leagues/79.png"
        },
        "country": {
            "name": "Germany",
            "code": "DE",
            "flag": "https://media.api-sports.io/flags/de.svg"
        },
        "seasons": [
            {
                "year": 2018,
                "start": "2018-08-03",
                "end": "2019-05-19",
                "current": false,
                "coverage": {
                    "fixtures": {
                        "events": true,
                        "lineups": true,
                        "statistics_fixtures": true,
                        "statistics_players": true
                    },
                    "standings": true,
                    "players": true,
                    "top_scorers": true,
                    "top_assists": true,
                    "top_cards": true,
                    "injuries": false,
                    "predictions": true,
                    "odds": false
                }
            },
            {
                "year": 2019,
                "start": "2019-07-26",
                "end": "2020-07-11",
                "current": false,
                "coverage": {
                    "fixtures": {
                        "events": true,
                        "lineups": true,
                        "statistics_fixtures": true,
                        "statistics_players": true
                    },
                    "standings": true,
                    "players": true,
                    "top_scorers": true,
                    "top_assists": true,
                    "top_cards": true,
                    "injuries": false,
                    "predictions": true,
                    "odds": false
                }
            },
            {
                "year": 2020,
                "start": "2020-09-18",
                "end": "2021-05-30",
                "current": false,
                "coverage": {
                    "fixtures": {
                        "events": true,
                        "lineups": true,
                        "statistics_fixtures": true,
                        "statistics_players": true
                    },
                    "standings": true,
                    "players": true,
                    "top_scorers": true,
                    "top_assists": true,
                    "top_cards": true,
                    "injuries": false,
                    "predictions": true,
                    "odds": false
                }
            },
            {
                "year": 2021,
                "start": "2021-07-23",
                "end": "2022-05-24",
                "current": false,
                "coverage": {
                    "fixtures": {
                        "events": true,
                        "lineups": true,
                        "statistics_fixtures": true,
                        "statistics_players": true
                    },
                    "standings": true,
                    "players": true,
                    "top_scorers": true,
                    "top_assists": true,
                    "top_cards": true,
                    "injuries": false,
                    "predictions": true,
                    "odds": false
                }
            },
            {
                "year": 2022,
                "start": "2022-07-15",
                "end": "2023-06-06",
                "current": false,
                "coverage": {
                    "fixtures": {
                        "events": true,
                        "lineups": true,
                        "statistics_fixtures": true,
                        "statistics_players": true
                    },
                    "standings": true,
                    "players": true,
                    "top_scorers": true,
                    "top_assists": true,
                    "top_cards": true,
                    "injuries": false,
                    "predictions": true,
                    "odds": false
                }
            },
            {
                "year": 2023,
                "start": "2023-07-28",
                "end": "2024-05-28",
                "current": false,
                "coverage": {
                    "fixtures": {
                        "events": true,
                        "lineups": true,
                        "statistics_fixtures": true,
                        "statistics_players": true
                    },
                    "standings": true,
                    "players": true,
                    "top_scorers": true,
                    "top_assists": true,
                    "top_cards": true,
                    "injuries": false,
                    "predictions": true,
                    "odds": false
                }
            },
            {
                "year": 2024,
                "start": "2024-08-02",
                "end": "2025-05-27",
                "current": true,
                "coverage": {
                    "fixtures": {
                        "events": true,
                        "lineups": true,
                        "statistics_fixtures": true,
                        "statistics_players": true
                    },
                    "standings": true,
                    "players": true,
                    "top_scorers": true,
                    "top_assists": true,
                    "top_cards": true,
                    "injuries": false,
                    "predictions": true,
                    "odds": true
                }
            }
        ]
    },
    {
        "league": {
            "id": 667,
            "name": "Friendlies Clubs",
            "type": "Cup",
            "logo": "https://media.api-sports.io/football/leagues/667.png"
        },
        "country": {
            "name": "World",
            "code": null,
            "flag": null
        },
        "seasons": [
            {
                "year": 2020,
                "start": "2020-01-07",
                "end": "2020-09-26",
                "current": false,
                "coverage": {
                    "fixtures": {
                        "events": true,
                        "lineups": true,
                        "statistics_fixtures": false,
                        "statistics_players": false
                    },
                    "standings": false,
                    "players": true,
                    "top_scorers": true,
                    "top_assists": true,
                    "top_cards": true,
                    "injuries": false,
                    "predictions": true,
                    "odds": false
                }
            },
            {
                "year": 2021,
                "start": "2021-01-01",
                "end": "2022-03-15",
                "current": false,
                "coverage": {
                    "fixtures": {
                        "events": true,
                        "lineups": true,
                        "statistics_fixtures": false,
                        "statistics_players": false
                    },
                    "standings": false,
                    "players": true,
                    "top_scorers": true,
                    "top_assists": true,
                    "top_cards": true,
                    "injuries": false,
                    "predictions": true,
                    "odds": false
                }
            },
            {
                "year": 2022,
                "start": "2022-03-16",
                "end": "2022-12-30",
                "current": false,
                "coverage": {
                    "fixtures": {
                        "events": true,
                        "lineups": true,
                        "statistics_fixtures": false,
                        "statistics_players": false
                    },
                    "standings": false,
                    "players": true,
                    "top_scorers": true,
                    "top_assists": true,
                    "top_cards": true,
                    "injuries": false,
                    "predictions": true,
                    "odds": false
                }
            },
            {
                "year": 2023,
                "start": "2023-01-03",
                "end": "2023-12-30",
                "current": false,
                "coverage": {
                    "fixtures": {
                        "events": true,
                        "lineups": true,
                        "statistics_fixtures": true,
                        "statistics_players": true
                    },
                    "standings": false,
                    "players": true,
                    "top_scorers": true,
                    "top_assists": true,
                    "top_cards": true,
                    "injuries": false,
                    "predictions": true,
                    "odds": false
                }
            },
            {
                "year": 2024,
                "start": "2024-01-04",
                "end": "2024-12-30",
                "current": false,
                "coverage": {
                    "fixtures": {
                        "events": true,
                        "lineups": true,
                        "statistics_fixtures": true,
                        "statistics_players": true
                    },
                    "standings": false,
                    "players": true,
                    "top_scorers": true,
                    "top_assists": true,
                    "top_cards": true,
                    "injuries": false,
                    "predictions": true,
                    "odds": false
                }
            },
            {
                "year": 2025,
                "start": "2025-01-03",
                "end": "2025-09-16",
                "current": true,
                "coverage": {
                    "fixtures": {
                        "events": true,
                        "lineups": true,
                        "statistics_fixtures": true,
                        "statistics_players": true
                    },
                    "standings": false,
                    "players": true,
                    "top_scorers": true,
                    "top_assists": true,
                    "top_cards": true,
                    "injuries": false,
                    "predictions": true,
                    "odds": true
                }
            }
        ]
    }
]



export const NEWS_POSTS = [
    {
        image: "images/blog/blog-01.jpg",
        tag: "Press conference",
        title: "We want to win every competition we're in",
        date: "16.05.25",
        type: "left"
    },
    {
        image: "images/blog/blog-02.jpg",
        tag: "Interview",
        title: "We haven’t reached our target just yet but we are close",
        date: "07.05.25",
        type: "right"
    },
    {
        image: "images/blog/blog-03.jpg",
        tag: "Season",
        title: "Polzin: “Our focus is solely on these 90 minutes”",
        date: "06.05.25",
        type: "right"
    },
    {
        image: "images/blog/blog-04.png",
        tag: "Academy",
        title: "THSV host South Korea U16s",
        date: "06.05.25",
        type: "right"
    },
];